import './assets/index.css'
import CyEditor from './lib'
export default CyEditor
